import { useEffect, useState } from "react";
import { flushSync } from "react-dom";
import "../styles/style.css";
import "../styles/arabic.css";
import "../styles/light-mode.css";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";


export default function Header() {

    const { t, i18n } = useTranslation();

    const navigate = useNavigate();
    const location = useLocation();

    const isArabic = location.pathname.startsWith("/ar");

    const langPath = (path) => {
        return isArabic ? `/ar${path}` : path;
    };

    const [menuOpen, setMenuOpen] = useState(false);

    const [lightMode, setLightMode] = useState(() => {
        return localStorage.getItem("light-mode") === "on";
    });

    useEffect(() => {
        document.body.classList.toggle("light-mode", lightMode);

        if (lightMode) {
            localStorage.setItem("light-mode", "on");
        } else {
            localStorage.removeItem("light-mode");
        }
    }, [lightMode]);


    useEffect(() => {
        document.documentElement.lang = i18n.language;

        document.body.classList.toggle(
            "arabic",
            i18n.language === "ar"
        );
    }, [i18n.language]);

    const toggleLanguage = () => {
        if (i18n.language === "en") {
            navigate("/ar" + location.pathname);
        } else {
            const newPath = location.pathname.replace(/^\/ar/, "") || "/";
            navigate(newPath);
        }
    };


    return (
        <header id="header">
            <img
                className="logo-header"
                src="/logo.png"
                alt="Mohamed Eltohamy Logo"
                loading="eager"
                draggable="false"
            />

            <div
                className={`hamburger ${menuOpen ? "active" : ""}`}
                id="menu-toggle"
                onClick={() => setMenuOpen((prev) => !prev)}
            >
                <div className="hamburger-child">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>

            <nav id="nav-links" className={menuOpen ? "active" : ""} >
                <ul>
                    <li>
                        <NavLink
                            to={langPath("/")}
                            end
                            className={({ isActive }) =>
                                `color-a ${isActive ? "active" : ""}`
                            }
                            onClick={() => setMenuOpen(false)}
                        >
                            <i className="fa fa-home"></i> {t("nav.home")}
                            <span></span>
                        </NavLink>
                    </li>

                    <li>
                        <NavLink
                            to={langPath("/about")}
                            className={({ isActive }) =>
                                `color-a ${isActive ? "active" : ""}`
                            }
                            onClick={() => setMenuOpen(false)}
                        >
                            <i className="fa-solid fa-address-card"></i> {t("nav.about")}
                            <span></span>
                        </NavLink>
                    </li>

                    <li>
                        <NavLink
                            to={langPath("/skills")}
                            className={({ isActive }) =>
                                `color-a ${isActive ? "active" : ""}`
                            }
                            onClick={() => setMenuOpen(false)}
                        >
                            <i className="fa-solid fa-user-gear"></i> {t("nav.skills")}
                            <span></span>
                        </NavLink>
                    </li>

                    <li>
                        <NavLink
                            to={langPath("/projects")}
                            className={({ isActive }) =>
                                `color-a ${isActive ? "active" : ""}`
                            }
                            onClick={() => setMenuOpen(false)}
                        >
                            <i className="fa fa-tasks"></i> {t("nav.projects")}
                            <span></span>
                        </NavLink>
                    </li>

                    <li>
                        <NavLink
                            to={langPath("/contact")}
                            className={({ isActive }) =>
                                `color-a ${isActive ? "active" : ""}`
                            }
                            onClick={() => setMenuOpen(false)}
                        >
                            <i className="fa-solid fa-comment"></i> {t("nav.contact")}
                            <span></span>
                        </NavLink>
                    </li>

                    <button
                        id="lang-btn"
                        className="active"
                        style={{ display: "none" }}
                    >
                        <i className="fa-solid fa-language"></i>
                        <span id="lang-text">Arabic</span>
                    </button>
                </ul>

                <div className="collect-div">

                    <div className="btn-ar-en">
                        <button className="lang-btn" onClick={toggleLanguage}>
                            <i className="fa-solid fa-globe"></i>
                            <span>{i18n.language === "en" ? "AR" : "EN"}</span>
                        </button>
                    </div>

                    <div className="switch-div">
                        <label className="switch">
                            <input
                                type="checkbox"
                                id="modeToggle"
                                checked={lightMode}
                                onChange={() => {
                                    const button = document.querySelector(".switch");

                                    const rect = button.getBoundingClientRect();

                                    const x = rect.left + rect.width / 2;
                                    const y = rect.top + rect.height / 2;

                                    const maxX = Math.max(x, window.innerWidth - x);
                                    const maxY = Math.max(y, window.innerHeight - y);

                                    const radius = Math.sqrt(
                                        maxX ** 2 + maxY ** 2
                                    );

                                    document.documentElement.style.setProperty(
                                        "--theme-x",
                                        `${x}px`
                                    );

                                    document.documentElement.style.setProperty(
                                        "--theme-y",
                                        `${y}px`
                                    );

                                    document.documentElement.style.setProperty(
                                        "--theme-radius",
                                        `${radius}px`
                                    );

                                    const newMode = !lightMode;

                                    if (!document.startViewTransition) {
                                        setLightMode(newMode);
                                        return;
                                    }

                                    document.startViewTransition(() => {
                                        flushSync(() => {
                                            setLightMode(newMode);
                                        });
                                    });
                                }}
                            />

                            <span className="slider">
                                
                                <svg className="blure">
                                    <filter
                                        id="lg-dist"
                                        x="0%"
                                        y="0%"
                                        width="100%"
                                        height="100%"
                                    >
                                        <feTurbulence
                                            type="fractalNoise"
                                            baseFrequency="0.020 0.020"
                                            numOctaves="2"
                                            seed="92"
                                            result="noise"
                                        />

                                        <feGaussianBlur
                                            in="noise"
                                            stdDeviation="2"
                                            result="blurred"
                                            />

                                        <feDisplacementMap
                                            in="SourceGraphic"
                                            in2="blurred"
                                            scale="200"
                                            xChannelSelector="R"
                                            yChannelSelector="G"
                                            />
                                    </filter>
                                </svg>
                            </span>
                        </label>
                    </div>
                </div>
            </nav>
        </header>
    );
}